import { Inject, Injectable, Input } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from 'src/app/core/services';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { Router } from '@angular/router';
import { API_BASE_URL } from 'src/app/core/services/appConfig/app-config.service';
import { environment } from 'src/environments/environment';
import { GlobalConstants } from '../constants/globalconstants';
import { UserPermissionService } from 'src/app/core/services/userPermission/user-permission.service';
import { SessionAutoRefreshService } from 'src/app/core/services/session-auto-refresh.service';

@Injectable()
export class SessionTrackingInterceptor implements HttpInterceptor {
  private readonly LOGIN_ROUTE_URL = '/authentication/login';
  private readonly RESPOND_LOGIN_URL = '/respond/login';
  currentUser: any;
  sessionWarningTimeInMins = 0;
  sessionTimeoutTimeInMins = 0;
  sessionWarningTimeoutId;
  sessionTimeoutId;
  timerIntervalId;
  sessionWarningDialogObj;
  sessionTimeoutDialogObj;

  respondSessionTimeoutTimeInMins = GlobalConstants.RespondSessionTimeoutTime;
  respondSessionWarningTimeInMins = GlobalConstants.RespondSessionWarningTime;
  respondSessionWarningTimeoutId;
  respondSessionTimeoutId;
  respondTimerIntervalId;
  respondSessionWarningDialogObj;
  respondSessionTimeoutDialogObj;

  errorDialogObj;
  sessionDialogsPosition = { X: 'center', Y: 'center' };
  remainingTime = 0;
  respondRemainingTime = 0;

  defaultSessionWarningTime = GlobalConstants.DefaultSessionWarningTime;
  defaultSessionTimeoutTime = GlobalConstants.DefaultSessionTimeoutTime;

  constructor(
    private router: Router,
    private userPermService: UserPermissionService,
    private authService: AuthenticationService,
    private sessionAutoRefreshService: SessionAutoRefreshService,
    @Inject(API_BASE_URL) public baseUrl?: string
  ) {
    this.currentUser = this.authService.CurrentUserValue;
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const loginFullUrl = `${this.baseUrl + environment.apiURL + this.LOGIN_ROUTE_URL}`;
    const respondLoginUrl = `${this.baseUrl + environment.apiURL + this.RESPOND_LOGIN_URL}`;
    const isUserOfTypeCMS = !GlobalConstants.RespondRoutes.includes(this.router.url);

    //session tracking is not required for login tracks and not for RESPOND
    if (request.url != respondLoginUrl && loginFullUrl != request.url && this.currentUser != null && isUserOfTypeCMS) {
      const isUserOfTypeCMS = !GlobalConstants.RespondRoutes.includes(this.router.url);
      const decodedToken = this.userPermService.getDecodedAccessToken(this.currentUser.AuthToken);
      if (isUserOfTypeCMS && decodedToken && decodedToken.loginType == GlobalConstants.LoginType_CMS) {
        const localStorageUser = JSON.parse(localStorage.getItem('currentuser'));

        //in case the current user available in the service method is found we are getting the data from localstorage
        this.sessionWarningTimeInMins = this.defaultSessionWarningTime;
        this.sessionTimeoutTimeInMins = this.defaultSessionTimeoutTime;
        /*
        if (this.currentUser) {
          if (this.currentUser.Company) {
            this.sessionWarningTimeInMins = this.currentUser.Company.SessionTimeoutWarning != null ?
              this.currentUser.Company.SessionTimeoutWarning : this.defaultSessionWarningTime;

            this.sessionTimeoutTimeInMins = this.currentUser.Company.SessionTimeout != null ?
              this.currentUser.Company.SessionTimeout : this.defaultSessionTimeoutTime;
          }
        }
        else if (localStorageUser) {
          if (localStorageUser.Company) {
            this.sessionWarningTimeInMins = localStorageUser.Company.SessionTimeoutWarning != null ?
              localStorageUser.Company.SessionTimeoutWarning : this.defaultSessionWarningTime;

            this.sessionTimeoutTimeInMins = localStorageUser.Company.SessionTimeout != null ?
              localStorageUser.Company.SessionTimeout : this.defaultSessionTimeoutTime;
          }
        }
*/
        if (localStorageUser) {
          if (localStorageUser.Company) {
            this.sessionWarningTimeInMins = localStorageUser.Company.SessionTimeoutWarning != null ?
              localStorageUser.Company.SessionTimeoutWarning : this.defaultSessionWarningTime;

            this.sessionTimeoutTimeInMins = localStorageUser.Company.SessionTimeout != null ?
              localStorageUser.Company.SessionTimeout : this.defaultSessionTimeoutTime;
          }
        }

        //if no data for user found session tracking is restricted
        if (this.currentUser || localStorageUser) {
          this.remainingTime = this.sessionTimeoutTimeInMins - this.sessionWarningTimeInMins;
          //clearing all previous session tracks and intervals
          clearTimeout(this.sessionWarningTimeoutId);
          clearTimeout(this.sessionTimeoutId);
          clearInterval(this.timerIntervalId);
          this.sessionWarningTimeoutId = setTimeout(() => {
            this.sessionAutoRefreshService.setWarningDialogShown(true);
            this.sessionWarningDialogObj = DialogUtility.confirm({
              title: '<div class = "e-icons e-warning d-inline-block"></div> WARNING',
              content: 'Your current CMS session will expire in ' + this.remainingTime + ' minutes. Click Continue to extend your session.',
              okButton: { text: 'Continue', click: this.ContinueSession.bind(this) },
              cancelButton: { text: 'Logout', click: this.LogoutFromWarning.bind(this) },
              showCloseIcon: false,
              closeOnEscape: false,
              animationSettings: { effect: 'Zoom' },
              position: this.sessionDialogsPosition
            });
            this.RunInterval();
          }, this.sessionWarningTimeInMins * 60000);

          this.sessionTimeoutId = setTimeout(() => {
            this.sessionWarningDialogObj.hide();
            this.sessionTimeoutDialogObj = DialogUtility.alert({
              title: 'Session Expired',
              content: 'Your current CMS session has expired. Please login again.',
              okButton: { text: 'Go To Login', click:() => {
                this.SessionExpired();}   
              },
              showCloseIcon: false,
              closeOnEscape: false,
              animationSettings: { effect: 'Zoom' },
              position: this.sessionDialogsPosition
            });
          }, this.sessionTimeoutTimeInMins * 60000);

          localStorage.setItem('sessionWarningId', this.sessionWarningTimeoutId);
          localStorage.setItem('sessionTimeoutId', this.sessionTimeoutId);
          localStorage.setItem('sessionIntervalTimerId', this.timerIntervalId);
        }
      }
    } else if (!isUserOfTypeCMS) {
        this.respondRemainingTime = this.respondSessionTimeoutTimeInMins - this.respondSessionWarningTimeInMins;
        clearTimeout(this.respondSessionWarningTimeoutId);
        clearTimeout(this.respondSessionTimeoutId);
        clearInterval(this.respondTimerIntervalId);

        this.respondSessionWarningTimeoutId = setTimeout(() => {
          this.sessionAutoRefreshService.setWarningDialogShown(true);
          this.respondSessionWarningDialogObj = DialogUtility.confirm({
            title: '<div class = "e-icons e-warning"> WARNING </div>',
            content: 'Your current CMS Respond session will expire in ' + this.respondRemainingTime + ' minutes. Click Continue to extend your session.',
            okButton: { text: 'Continue', click: this.ContinueRespondSession.bind(this) },
            cancelButton: { text: 'Logout', click: this.LogoutFromRespondWarning.bind(this) },
            showCloseIcon: false,
            closeOnEscape: false,
            animationSettings: { effect: 'Zoom' },
            position: this.sessionDialogsPosition
          });
          this.RunIntervalRespond();
      }, this.respondSessionWarningTimeInMins * 60000);

        this.respondSessionTimeoutId = setTimeout(() => {
          this.respondSessionWarningDialogObj.hide();
          this.respondSessionTimeoutDialogObj = DialogUtility.alert({
            title: 'Session Expired',
            content: 'Your current CMS Respond session has expired. Please login again.',
            okButton: { text: 'Go To Login', click:() => {
              this.authService.logout();
              window.location.reload();
              this.RespondSessionExpired.bind(this);}   
            },
            showCloseIcon: false,
            closeOnEscape: false,
            animationSettings: { effect: 'Zoom' },
            position: this.sessionDialogsPosition
          });
        }, this.respondSessionTimeoutTimeInMins * 60000);

        localStorage.setItem('respondSessionWarningId', this.respondSessionWarningTimeoutId);
        localStorage.setItem('respondSessionTimeoutId', this.respondSessionTimeoutId);
        localStorage.setItem('respondSessionIntervalTimerId', this.respondTimerIntervalId);
    }
    return next.handle(request);
  }

  /**
   * Continuing session with latest user details
   */
  ContinueSession() {
    clearInterval(this.timerIntervalId);
    this.sessionAutoRefreshService.setWarningDialogShown(false);
    if (this.sessionWarningDialogObj) {
      this.sessionWarningDialogObj.hide();
    }
    this.authService.FetchUserRefreshToken().subscribe(resp => {

    },
      error => {
        console.log(error);
        if (this.sessionWarningDialogObj) {
          this.sessionWarningDialogObj.hide();
        }
        this.errorDialogObj = DialogUtility.alert({
          content: 'Something went wrong with the session. Please try to login again.',
          okButton: { text: 'Retry Login', click: this.OnContinueSessionErrorRedirectToLogin.bind(this) },
          showCloseIcon: false,
          closeOnEscape: false,
          animationSettings: { effect: 'Zoom' },
          position: this.sessionDialogsPosition
        });

        setTimeout(() => {
          this.OnContinueSessionErrorRedirectToLogin();
        }, 3000);
      });
  }

  LogoutFromWarning() {
    clearInterval(this.timerIntervalId);
    this.sessionAutoRefreshService.setWarningDialogShown(false);
    if (this.sessionWarningDialogObj) {
      this.sessionWarningDialogObj.hide();
    }
    this.authService.logout();
    this.router.navigate(['/']);
  }

  ContinueRespondSession() {
    clearInterval(this.respondTimerIntervalId);
    this.sessionAutoRefreshService.setWarningDialogShown(false);
    if (this.respondSessionWarningDialogObj) {
      this.respondSessionWarningDialogObj.hide();
    }
    this.authService.FetchRespondRefreshToken((JSON.parse(localStorage.getItem('responduser'))).CaseNumber)
    .subscribe(resp => {
    },
      error => {
        console.log(error);
        if (this.respondSessionWarningDialogObj) {
          this.respondSessionWarningDialogObj.hide();
        }
        this.errorDialogObj = DialogUtility.alert({
          content: 'Something went wrong with the session. Please try to login again.',
          okButton: { text: 'OK', click: this.OnContinueSessionErrorRedirectToRespond.bind(this) },
          showCloseIcon: false,
          closeOnEscape: false,
          animationSettings: { effect: 'Zoom' },
          position: this.sessionDialogsPosition
        });

        setTimeout(() => {
          this.OnContinueSessionErrorRedirectToRespond();
        }, 3000);
      });
  }

  LogoutFromRespondWarning() {
    clearInterval(this.respondTimerIntervalId);
    this.sessionAutoRefreshService.setWarningDialogShown(false);
    if (this.respondSessionWarningDialogObj) {
      this.respondSessionWarningDialogObj.hide();
    }
    this.authService.logout();
    this.router.navigate(['/respond']);
  }

  /**
   * Clearing details and loggin out user due to session expiration
   */
  SessionExpired() {
    clearInterval(this.timerIntervalId);
    this.sessionTimeoutDialogObj.hide();
    this.authService.logout();
    this.router.navigate(['/']);
    this.authService.sendClickEvent();
  }

  RespondSessionExpired() {
    clearInterval(this.respondTimerIntervalId);
    this.respondSessionTimeoutDialogObj.hide();
    this.authService.logout();
    this.router.navigate(['/respond']);
    this.authService.sendClickEvent();
  }

  /**
   * Dynamically change the remaining time for session timeout, this will update
   * the remaining time by every one minutes
   */
  RunInterval() {
    this.timerIntervalId = setInterval(() =>
      this.StartTimeTick(this.remainingTime)
      , 1000 * 60);
  }

  RunIntervalRespond() {
    this.respondTimerIntervalId = setInterval(() =>
      this.StartTimeTickRespond(this.respondRemainingTime)
      , 1000 * 60);
  }

  /**
   * The actual method which is responsible for updating the remaining time
   */
  StartTimeTick(currentTime: any) {
    if (this.sessionWarningDialogObj) {
      currentTime -= 1;
      const tempsessionWarningDialogObj = this.sessionWarningDialogObj;
      tempsessionWarningDialogObj.content = 'Your current CMS session will expire in ' + currentTime + ' minutes. Click Continue to extend your session.';
      this.sessionWarningDialogObj = tempsessionWarningDialogObj;
      this.remainingTime = currentTime;
    }
  }

  StartTimeTickRespond(currentTime: any) {
    if (this.respondSessionWarningDialogObj) {
      currentTime -= 1;
      const tempsessionWarningDialogObj = this.respondSessionWarningDialogObj;
      tempsessionWarningDialogObj.content = 'Your current CMS Respond session will expire in ' + currentTime + ' minutes. Click Continue to extend your session.';
      this.respondSessionWarningDialogObj = tempsessionWarningDialogObj;
      this.respondRemainingTime = currentTime;
    }
  }

  /**
   * Handling the app for any status code for erros while retriving refresh token
   */
  OnContinueSessionErrorRedirectToLogin() {
    if (this.errorDialogObj) {
      this.errorDialogObj.hide();
    }
    this.authService.logout();
    this.router.navigate(['/']);
  }

  OnContinueSessionErrorRedirectToRespond() {
    if (this.errorDialogObj) {
      this.errorDialogObj.hide();
    }
    this.authService.logout();
    this.router.navigate(['/respond']);
  }
}
